import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { Store } from '@ngrx/store';
import { map } from 'rxjs/operators';
import { combineLatest, Observable } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { WindowService } from '@core/services/window/window.service';
import { ComponentCanDeactivateDirective } from '@core/guards/can-deactivate/can-deactivate';
import { SubmittalsState } from '@submittals/reducers';
import { selectIsProcessingSubmittalAction } from '@submittals/selectors/submittal-workflow-action-form/submittal-workflow-action-form.selectors';

@Injectable()
export class CanDeactivateSubmittalWorkflowProcessGuard implements CanDeactivate<ComponentCanDeactivateDirective> {
  constructor(
    private translateService: TranslateService,
    private windowService: WindowService,
    private store: Store<SubmittalsState>
  ) {}

  canDeactivate(): Observable<boolean> {
    return combineLatest([
      this.store.select(selectIsProcessingSubmittalAction),
      this.translateService.get('SUBMITTALS.ACTION_FORM.ERROR.ACTION_ERROR')
    ]).pipe(
      map(([isProcessingAction, confirmationMessage]) =>
        isProcessingAction ? this.windowService.confirm(confirmationMessage) : true
      )
    );
  }
}
